{
    "InlineExitMessage": "Weet je zeker dat je dit venster wilt sluiten? Alle gewijzigde configuraties gaan verloren bij het sluiten.",
    "InlineExitConfirm": "Bevestig",
    "InlineExitCancel": "Annuleren",
    "NotificationsModalTitle": "Meldingen",
    "TabSettingsTitle": "Instellingen",
    "TabSettingsDoNotDisturb": "inschakelen",
    "TabSettingsCME": "CME",
    "TabSettingsTelServer": "Telefonie server",
    "TabSettingsPartition": "Verdeling \/ Locatie",
    "TabSettingsDevices": "Apparaten",
    "TabSettingsChannels": "Kanalen",
    "TabSettingsPhoneNumber": "Telefoonnummer",
    "TabSettingsHeaderGeneral": "Algemeen",
    "TabSettingsHeaderScopeFiltering": "Bereik filteren",
    "TabSettingsNotificationChannels": "Meldingskanalen",
    "TabSetttingsPartitionValidation": "Je kunt maximaal 5 partities selecteren.",
    "TabPreferencesTitle": "Voorkeuren",
    "TabPreferencesHeadingUserNotifications": "Gebruikersmeldingen",
    "IconAddTooltip": "Meldingen toevoegen",
    "IconDisabledTooltip": "Meldingen zijn uitgeschakeld",
    "IconEnabledTooltip": "Meldingen zijn ingeschakeld",
    "IconDisabled": "Uitgeschakeld",
    "NotificationsFooterHelp": "Help",
    "NotificationsFooterCancel": "Annuleren",
    "NotificationsFooterSubmit": "Sla",
    "NotificationsFooterValiationWarning": "Corrigeer fouten voordat je klaar bent",
    "NotificationPrefereencesThreshholdPlaceholder": "Plaatshouder",
    "NotificationPrefereencesThreshholdRequired": "Drempel is vereist",
    "NotificationPrefereencesThreshholdInvalid": "Drempel moet een getal zijn",
    "NotificationFooterValidationError": "Validatiefouten",
    "NAME": "NotificationsLanguageModal"
}